import Button from "../../../button/button";
import InputAnimated from "../../../inputAnimated/inputAnimated";
import Modal from "../../../modal/modal";
import PasswordAlert from "../../../passwordAlert/passwordAlert";
import './ExchangeRateRegister.scss'
import React, { useState } from "react";
import Axios from "axios";
import Alert from "../../../alert/Alert";
import { PostReceptionistInCharge } from "../../../../utils/Apis/apis";
const ExchangeRateRegister = ({ onClose, isOpen }) => {
    // Define el estado para los handlers del modal
    const [modalHandlers, setModalHandlers] = useState({
        handleAcceptPassword: () => { },
        handleCancelPassword: () => { },
    });
    const [exchangeRate, setExchangeRate] = useState('')
    //ALERT
    const [isVisibleAlert, setIsVisibleAlert] = useState(false);
    const [arrayAlerts, setArrayAlerts] = useState([])
    // PasswordModal Confirm
    const [isModalPasswordConfirmOpen, setIsModalPasswordConfirmOpen] = useState(false);
    const [modalPasswordDetailAction, setModalPasswordDetailAction] = useState('Ingrese las credenciales')
    const [modalPasswordDetailTitle, setModalPasswordDetailTitle] = useState('Identificacion')
    const [disabledButton, setDisabledButton] = useState(false)
    const handleConfirmExchangeRate = async () => {
        setDisabledButton(true)
        const checkPasswordConfirm = await ConfirmActionPassword();
        const { status, message } = checkPasswordConfirm;

        if (status) {
            if (!exchangeRate) {
                setDisabledButton(false)
                return showAlert('danger', 'Ingresa el tipo de cambio del dólar');
            }
            if (exchangeRate < 0) {
                setDisabledButton(false)
                return showAlert('danger', 'El tipo de cambio no puede ser negativo');
            }

            const handleExchangeRate = await handleUSDUpdateExchangeRate(exchangeRate);
            const { status: statusEc, message: msgEc } = handleExchangeRate;

            const alertType = statusEc === 200 ? 'success' : 'info';
            showAlert(alertType, msgEc);
            if (statusEc === 200) {
                setTimeout(() => {
                    onClose()
                    setDisabledButton(false)
                }, 2000);
            } else {
                setDisabledButton(false)
            }
        }
    };

    // Función auxiliar para mostrar alertas
    const showAlert = (type, message) => {
        const id = Math.floor(Math.random() * 100) + 1;
        const alertObj = { id, type, message };

        setArrayAlerts(oldArray => [alertObj, ...oldArray]);
        setIsVisibleAlert(true);
    };

    const ConfirmActionPassword = () => {
        return new Promise((resolve) => {
            setIsModalPasswordConfirmOpen(true);

            const handleAcceptPassword = async (formValues) => {
                const { employee_id, password } = formValues;

                if (!employee_id || !password) {
                    return showAlert('danger', 'Ingrese el correo y la contraseña para verificar sus credenciales.');
                }

                try {
                    const response = await PostReceptionistInCharge(formValues);
                    let status = response.status;

                    if (response.hasOwnProperty("auth")) {
                        status = 202;
                    }

                    switch (status) {
                        case 200:
                            setIsModalPasswordConfirmOpen(false);
                            resolve({ status: true, message: "Edición Permitida" });
                            break;
                        case 201:
                            showAlert('info', 'Credenciales rechazadas para realizar la edición.');
                            break;
                        case 202:
                            showAlert('info', "Credenciales expiradas");
                            break;
                        default:
                            showAlert('info', "Error desconocido al verificar credenciales.");
                            break;
                    }
                } catch (error) {
                    console.error(error);
                    showAlert('danger', "Error al verificar credenciales.");
                }
            };

            const handleCancelPassword = () => {
                setIsModalPasswordConfirmOpen(false);
                resolve(false);
            };

            setModalHandlers({ handleAcceptPassword, handleCancelPassword });
        });
    };


    const handleUSDUpdateExchangeRate = async (value) => {
        try {
            const res = await Axios.patch(process.env.REACT_APP_API_URL + "patchUSDCurrency/", {
                exchange_rate: value
            }, {
                headers: {
                    "x-access-token": localStorage.getItem("token"),
                },
            })
            return res.data
        } catch (error) {
            console.log(error)
        }
    }
    return (
        <Modal isOpen={isOpen} onClose={onClose} overlayClick={false}>
            <div className="exchange-rate-register">
                <h1 className="title-1">Tipo de cambio</h1>
                <InputAnimated type="number" placeholder='Ingresa tipo de cambio' value={exchangeRate} onChange={(e) => setExchangeRate(e.target.value)} />
                <div className="confirm-buttons-section">
                    <Button disabled={disabledButton} text='Cancelar' backgroundColor="red" onClick={onClose} />
                    <Button disabled={disabledButton} text='Confirmar' onClick={handleConfirmExchangeRate} />

                </div>
            </div>
            <div className="divAlert">
                <Alert arrayAlertsModule={arrayAlerts} setArrayAlertsModule={setArrayAlerts} isVisibleModule={isVisibleAlert} setIsVisibleModule={setIsVisibleAlert} />
            </div>
            <PasswordAlert
                isOpen={isModalPasswordConfirmOpen}
                handleAccept={modalHandlers.handleAcceptPassword}
                handleCancel={modalHandlers.handleCancelPassword}
                text={modalPasswordDetailAction}
                title={modalPasswordDetailTitle}
            />
        </Modal>
    )
}
export default ExchangeRateRegister;